import React, { useEffect, useState, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import styles from './ApplicationsPage.module.scss';
import ScholarshipDetails from '../../Molecules/detailsBox/scholarshipDetailsBox';
import TableTopHeader from '../../Molecules/TableTopHeader/ApplicationsTableTopHeader';
import ApplicantsTable from '../../Molecules/Applications/ApplicantsTable';
import {
  DetailsContext,
  PageTitleContext,
} from '../../HOC/GeneralBody/GeneralBody';
import {
  useFetchScholarship,
  useExportTableScholarship,
  useFetchSingleScholarship,
} from '../../../Hooks/Applications';

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const HeaderAttr = useContext(PageTitleContext);
  const [selected, setSelected] = useState('scholarship');
  const [scholarshipNumber, setScholarshipNumber] = useState(0);
  const [applicationId, setApplicationId] = useState('');
  const Details = useContext(DetailsContext);

  const [search, setSearch] = useState();
  const [order, setOrder] = useState(['', 'asc']);
  const [mode, setMode] = useState('scholarship');
  const { id } = useParams();

  const {
    data: scholarship,
    refetch: refetchScholarship,
    isLoading: isLoading,
  } = useFetchScholarship({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: scholarshipPrint,
    refetch: refetchScholarshipPrint,
    isLoading: isLoading0000,
  } = useFetchScholarship({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: ScholarshipbyId, refetch: refetchSingleScholarship } =
    useFetchSingleScholarship(Details.details);

  const exportScholarshipTable = useExportTableScholarship();
  const handleExportTable = async () => {
    try {
      var data = await exportScholarshipTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'ScholarshipsTable';
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Unexpected data type. Expected string.');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  useEffect(() => {
    refetchSingleScholarship();
  }, []);

  const applicantsTableHeader = [
    {
      name: 'الاسم الأول',
      originalName: 'firstName',
    },
    {
      name: 'الاسم الأخير',
      originalName: 'lastName',
    },
    {
      name: 'البريد الإلكتروني',
      originalName: 'email',
    },
    {
      name: 'الهاتف',
      originalName: 'phoneNumber',
    },
    {
      name: 'نوع الدرجة',
      originalName: 'degreeType',
    },
    {
      name: 'التاريخ',
      originalName: 'date',
    },
  ];

useEffect(() => {
  if (Details.details) {
    HeaderAttr.setMoveRight('40px');
    HeaderAttr.setPathName('تفاصيل المنحة');
  } else {
    HeaderAttr.setMoveRight('2px');
    HeaderAttr.setPathName('المنح الدراسية');
    Details.setDetails(null);
  }
}, [Details.details]);


  useEffect(() => {
    refetchScholarship();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (scholarship && !scholarshipNumber) {
      setScholarshipNumber(scholarship && scholarship.data.totalCount);
    }
  }, [scholarship]);

  const [moveRight, setMoveRight] = useState(false);

  useEffect(() => {
    setSearch('');
    setPage(1);
    setPageSize(10);
    setOrder(['', 'asc']);
  }, [selected]);

  return (
    <>
      {!Details.details ? (
        <div className={styles['table-container']}>
          <TableTopHeader
            mode={mode}
            handleExport={handleExportTable}
            search={search}
            setSearch={setSearch}
            title="Scholarship Table"
            data={scholarshipPrint?.data}
            refetch={refetchScholarshipPrint}
            tableHeader={applicantsTableHeader}
          />
          <ApplicantsTable
            data={scholarship?.data}
            tableHeader={applicantsTableHeader}
            mode={mode}
            page={Page}
            setPage={setPage}
            pageSize={PageSize}
            setPageSize={setPageSize}
            setDetails={Details.setDetails}
            details={Details.details}
            setApplicationId={setApplicationId}
            order={order}
            setOrder={setOrder}
            refetch={refetchScholarship}
            setMoveRight={setMoveRight}
            isLoading={isLoading}
          />
        </div>
      ) : (
        <>
          <ScholarshipDetails
            data={ScholarshipbyId && ScholarshipbyId?.data}
            setDetails={Details.setDetails}
            details={Details.details}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
